(function (
    global,
    $,
    moduleRegistrar,
    Module,
    Modal,
    localStorageHelper,
    objectHelper,
    undefined
) {
    class BarfunkBookingCalendar
    {
        selectors = {
            eventCalendar: '[data-js="event_calendar"]',
        };

        constructor()
        {
            this.init();
        }

        init()
        {
            if ($('[data-js="event_calendar"][data-ajax="true"]').length) {
                $(this.selectors.eventCalendar)
                    .find('[data-js="calendar_prev"] a, [data-js="calendar_next"] a')
                    .attr('href', '');

                $(this.selectors.eventCalendar)
                    .find('[data-js="calendar_prev"], [data-js="calendar_next"]')
                    .on('click', e => {
                    e.preventDefault();
                    this.initCalendarAjax(
                        $(e.currentTarget).data('month'),
                        $(e.currentTarget).data('year')
                    );
                });
            }
        }

        initCalendarAjax(month, year)
        {
            $.ajax({
                type: 'POST',
                url: woocommerce_params.ajax_url,
                data: {
                    action: 'barfunk_event_calendar',
                    month: month,
                    year: year
                },
                success: result => {
                    $(this.selectors.eventCalendar).html(result);
                    $(this.selectors.eventCalendar)
                        .find('[data-js="calendar_prev"], [data-js="calendar_next"]')
                        .on('click', (e) => {
                            e.preventDefault();
                            this.initCalendarAjax(
                                $(e.currentTarget).data('month'),
                                $(e.currentTarget).data('year')
                            );
                        });

                    $(document).trigger('barfunk:event-calendar:ajax:loaded');
                },
                error: function (error) {
                    console.log(error);
                },
            });
        }
    }

    class BarfunkReservation
    {
        id = 'barfunk_reservation';

        state = {
            venue: null,
            table: null,
            date: null,
        };

        tableSelection = {};
        
        selectors = {
            venueOptions: 'input[name="venue_options"]',
            barfunkTableOptions: 'input[name="barfunk_table_options"]',
            armaniaTableOptions: 'input[name="armania_table_options"]',
            eventReservationButton: '.barfunk-event-reservation-button',
            eventTicketButton: '.barfunk-event-ticket-button',
            eventReservationLinkInput: 'input[name="barfunk_event_reservation_link"]',
            eventTicketLinkInput: 'input[name="barfunk_event_ticket_link"]',
            calendarDay: '[data-js="event_calendar_day"]',
            calendarEvent: '[data-js="event_calendar_event"]',
            calendarDayBookBtn: '[data-js="event_calendar_day_book_btn"]',
            calendarModalViewEvent: '[data-js="calendar_modal_view_event"]',
            calendarConfirmModalButton: '[data-js="calendar_modal_confirm_date"]',
            removeSelectedTableButton: '[data-js="remove_selected_table"]',
        };

        calendarConfirmModal = null;

        addToCartModal = null;

        constructor()
        {
            this.init();
        }
        
        init()
        {
            if (! $('[data-js="multistep"]').length) {
                return;
            }

            $(document).on('barfunk:event-calendar:ajax:loaded', this.init.bind(this));

            $('input[name*="_table_options"]').prop('checked', false);

            this.setStateFromUrl();

            let currentStepName = $('[data-js="multistep-section"].active').attr('data-step-name');

            if ('date' === currentStepName) {
                $('[data-js="next-step"]').prop('disabled', true);
            }

            if ('table' === currentStepName) {
                let visualOptions = $('[data-js="multistep-section"].active').find('.c-visual-options input:checked');

                if (! visualOptions.length) {
                    $('[data-js="next-step"]').prop('disabled', true);
                } else {
                    $('[data-js="next-step"]').prop('disabled', false);
                }
            }

            $('[data-js="multistep"]').on('multistep:event:step:before-next', (e, data) => {
                $('[data-js="next-step"]').prop('disabled', true);

                if ('floorplan' === data.to.name) {
                    this.initFloorPlan();
                }
            });

            $('[data-js="multistep"]').on('multistep:event:step:after-next', (e, data) => {
                let currentStep = $('[data-js="multistep-section"][data-step-name="' + data.to.name + '"]');

                if (! currentStep.length) {
                    return;
                }

                let visualOptions = $(currentStep).find('.c-visual-options input:checked');

                if (! visualOptions.length) {
                    $('[data-js="next-step"]').prop('disabled', true);
                } else {
                    $('[data-js="next-step"]').prop('disabled', false);
                }
            });

            $('[data-js="multistep"]').on('multistep:event:step:validate', (e, step) => {
                let index = parseInt($('[data-js="multistep-section"].active').attr('data-step-index'));

                if ($('[data-js="multistep"]').hasClass('is-last-step')) {
                    e.result = true;
                    return;
                }

                if (step.step < 1 || step.step === index) {
                    e.result = true;
                    return;
                }

                let checkedStepOptions = $('[data-js="multistep-section"][data-step-index="' + step.step + '"]').find('input[name*="_options"][type="radio"]:checked');

                if (! checkedStepOptions.length) {
                    e.result = false;
                    return;
                }

                e.result = true;
            });

            $('[data-js="multistep"]').on('multistep:event:step:validated', (e, result) => {
                $('[data-js="next-step"]').prop('disabled', ! result.passed);
            });

            // $('.barfunk-reservation-summary .barfunk-multistep-summary-item').on('click', (e) => {
            //     if (! $(e.currentTarget).hasClass('completed')) {
            //         return;
            //     }
            //
            //     $('[data-js="multistep"]').trigger('multistep:trigger:step:goto', [
            //         $(e.currentTarget).index()
            //     ]);
            // });

            $('.barfunk-reservation-back-to-table-types a').on('click', e => {
                $('[data-js="multistep"]').trigger('multistep:trigger:step:prev');
            });

            $('.barfunk-reservation-check-out a').on('click', e => {
                e.preventDefault();

                const selectedTables = Object.fromEntries(
                    Object.entries(this.tableSelection).filter(([key, value]) => value)
                );

                $.ajax({
                    type: 'POST',
                    url: woocommerce_params.ajax_url,
                    data: {
                        action: 'barfunk_table_info',
                        table: Object.keys(selectedTables),
                        date: this.getState('date'),
                    },
                    success: result =>{
                        $(document).trigger('barfunk_booking_select_table', result);
                    },
                    error: error => {
                        console.log(error);
                    },
                });
            });

            $(this.selectors.venueOptions).on(
                'change',
                this.onChangeVenueOptions.bind(this)
            );
            $(this.selectors.barfunkTableOptions).on(
                'change',
                this.onChangeTableOptions.bind(this)
            );
            $(this.selectors.armaniaTableOptions).on(
                'change',
                this.onChangeTableOptions.bind(this)
            );
            $(this.selectors.eventReservationButton).on(
                'click',
                this.onClickEventReservationButton.bind(this)
            );
            $(this.selectors.eventTicketButton).on(
                'click',
                this.onClickEventTicketButton.bind(this)
            );
            $(this.selectors.calendarEvent).on(
                'click',
                this.onClickCalendarEvent.bind(this)
            );
            $(this.selectors.calendarDayBookBtn).on(
                'click',
                this.onClickCalendarDayBookBtn.bind(this)
            );
            $(this.selectors.calendarConfirmModalButton).on(
                'click',
                this.onClickCalendarConfirmModalButton.bind(this)
            );

            this.addToCartModal = new Modal('floorplan-confirm-table-modal');

            $(document).on('click', '[data-js="ajax-add-to-cart"]', this.singleAjaxAddToCart.bind(this));

            $('[data-modal="floorplan-confirm-table-modal"] button[data-js="modal-close"]').on('click', function () {
                $(document).trigger('barfunk_booking_modal_closed');
            });

            $(document).on('barfunk_booking_select_table', this.onSelectTable.bind(this));

            this.updateTableInfo();
        }

        updateTableInfo()
        {
            $.ajax({
                type: 'POST',
                url: woocommerce_params.ajax_url,
                data: {
                    action: 'barfunk_table_info',
                    tables: [
                        'BARFUNK-HT-2P',
                        'BARFUNK-HT-4P',
                        'BARFUNK-VIP-S-5P',
                        'ARMANIA-HT-2P',
                        'ARMANIA-VIP-HT-8P',
                        'ARMANIA-VIP-S-5P',
                        'ARMANIA-VVIP-S-12P',
                    ],
                    date: this.getState('date'),
                },
                success: result =>{
                    if (typeof result === 'string') {
                        result = JSON.parse(result);
                    }

                    Object.keys(result).forEach(sku => {
                        if (! result.hasOwnProperty(sku)) {
                            return;
                        }

                        if (! result[sku].hasOwnProperty('details')) {
                            return;
                        }

                        $('[data-table-info="' + sku + '"]').html(
                            `<p class="mt-0" style="font-size:0.8rem" data-table-info="${sku}">
                                ${ result[sku].details.pax ? '<strong>PAX: </strong>' + result[sku].details.pax + ' (free entry for ' + result[sku].details.pax + ' PAX)<br>' : '' }
                                ${ result[sku].details.maxPax ? '<strong>Max PAX: </strong>' + result[sku].details.maxPax + ' <strong>*</strong><br>' : '' }
                                <strong>Minimum spend for food, beverage, and merchandise:</strong> ${ result[sku].details.minSpend }
                            </p>`
                        );
                    });
                },
                error: error => {
                    console.log(error);
                },
            });
        }

        capitalizeFirstLetter(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        initFloorPlan()
        {
            $.imageMapProReInitMap('Booking Floorplan');

            const venue = this.getState('venue');
            const table = this.getState('table');

            if (venue.toLowerCase().includes('armania') && table && table.toLowerCase().includes('vip')) {
                $.imageMapProGoToFloor('Booking Floorplan', 'Armania VIP');
            } else if (venue) {
                $.imageMapProGoToFloor('Booking Floorplan', this.capitalizeFirstLetter(venue));
            } else {
                $.imageMapProGoToFloor('Booking Floorplan', 'Overview');
            }

            $.imageMapProInitialized = () => {
                this.highlightTables(this.getState('table'));
                this.setTableAvailability();

                // Map click events.
                $.imageMapProEventClickedShape = (imageMapName, shapeTitle) => {

                    // Switch floor.
                    if (shapeTitle.toLowerCase().includes('floor')) {
                        $.imageMapProGoToFloor('Booking Floorplan', shapeTitle);
                        return;
                    }

                    if (shapeTitle.toLowerCase().includes('back')) {
                        $.imageMapProGoToFloor('Booking Floorplan', 'Overview');
                        return;
                    }

                    if ($('[data-shape-title="' + shapeTitle + '"].table-unavailable').length) {
                        return;
                    }

                    if (! this.tableSelection.hasOwnProperty(shapeTitle) || ! this.tableSelection[shapeTitle]) {
                        this.selectTable(imageMapName, shapeTitle);
                    } else {
                        this.deselectTable(imageMapName, shapeTitle);
                    }

                    // Table info on table click.
                    // $.ajax({
                    //     type: 'POST',
                    //     url: woocommerce_params.ajax_url,
                    //     data: {
                    //         action: 'barfunk_table_info',
                    //         table: shapeTitle,
                    //         date: this.getState('date'),
                    //     },
                    //     success: result =>{
                    //         $(document).trigger('barfunk_booking_select_table', result);
                    //     },
                    //     error: error => {
                    //         console.log(error);
                    //     },
                    // });

                    $(document).on('barfunk_booking_modal_closed', () => {
                        $.imageMapProUnhighlightShape(imageMapName, shapeTitle);
                    });
                };
            };
        }

        selectTable(imageMapName, shapeTitle)
        {
            $.imageMapProHighlightShape(imageMapName, shapeTitle);
            this.tableSelection[shapeTitle] = true;

            this.updateTableSelectionInfo(imageMapName);
        }

        deselectTable(imageMapName, shapeTitle)
        {
            $.imageMapProUnhighlightShape(imageMapName, shapeTitle);
            this.tableSelection[shapeTitle] = false;

            this.updateTableSelectionInfo(imageMapName);
        }

        updateTableSelectionInfo(imageMapName)
        {
            const selectedTables = Object.fromEntries(
                Object.entries(this.tableSelection).filter(([key, value]) => value)
            );

            $('.barfun-reservation-info-table-selection').html(
                `<ul>
                    ${ Object.keys(selectedTables).map(table => `<li>${table} <span class="icon icon-close" data-js="remove_selected_table" data-table="${table}"></span></li>`).join('') }
                </ul>`
            );

            $(this.selectors.removeSelectedTableButton).off().on(
                'click',
                e => this.onClickRemoveSelectedTableButton(e, imageMapName)
            );

            if (Object.keys(selectedTables).length) {
                $('.barfunk-multistep-summary-item-table-selection').addClass('completed');
                return;
            }

            $('.barfunk-multistep-summary-item-table-selection').removeClass('completed');
        }

        setStateFromUrl()
        {
            $('[data-js="multistep"]').trigger('multistep:trigger:state:clear');

            let currentUrl = new URL(window.location);
            let date = currentUrl.searchParams.get('date');
            let venue = currentUrl.searchParams.get('venue');

            if (date && 'false' !== date) {
                this.setState('date', date);
                this.setState('venue', null);
                this.setState('table', null);

                this.updateTableInfo();
            }

            if (venue) {
                this.setState('venue', venue);
                this.setState('table', null);
                this.toggleTableOptions(venue);
            }
        }
        
        onChangeVenueOptions(e)
        {
            let venue = $(e.currentTarget).val();

            this.setState('venue', venue);
            this.setState('table', null);
            this.toggleTableOptions(venue);

            let index = $(e.currentTarget).closest('[data-js="multistep-section"]').data('stepIndex');

            $('[data-js="multistep"]').trigger('multistep:event:step:validated', {
                step: index,
                passed: true,
            });
        }
        
        onChangeTableOptions(e)
        {
            const table = $(e.currentTarget).val();
            const name = $(e.currentTarget).attr('name');

            if ('barfunk_table_options' === name) {
                $('input[name="armania_table_options"]').prop('checked', false);
                this.setState('venue', 'barfunk');
            } else if ('armania_table_options' === name) {
                $('input[name="barfunk_table_options"]').prop('checked', false);
                this.setState('venue', 'armania');
            }

            this.setState('table', table);

            let index = $(e.currentTarget).closest('[data-js="multistep-section"]').data('stepIndex');

            $('[data-js="multistep"]').trigger('multistep:event:step:validated', {
                step: index,
                passed: true,
            });
        }

        onClickEventReservationButton(e)
        {
            e.preventDefault();

            let link = $(this.selectors.eventReservationLinkInput).val();

            $(this.selectors.eventReservationButton).find('a').attr('href', link);
            $(this.selectors.eventReservationButton).off('click');

            window.location = $(this.selectors.eventReservationButton).find('a').attr('href');
        }

        onClickEventTicketButton(e)
        {
            e.preventDefault();

            let link = $(this.selectors.eventTicketLinkInput).val();

            $(this.selectors.eventTicketButton).find('a').attr('href', link);
            $(this.selectors.eventTicketButton).off('click');

            window.location = $(this.selectors.eventTicketButton).find('a').attr('href');
        }

        onClickCalendarEvent(e)
        {
            e.preventDefault();
            this.confirmCalendarDateDialog(e.currentTarget, true);
        }

        onClickCalendarDayBookBtn(e)
        {
            this.confirmCalendarDateDialog(e.currentTarget);
        }

        onClickCalendarConfirmModalButton(e)
        {
            $('[data-js="multistep"]').trigger('multistep:trigger:state:clear');

            const date = $(e.currentTarget).attr('data-date');
            this.setState('date', date);

            $('[data-modal="booking-calendar-confirm-modal"]').removeClass('active');
            $('html').removeClass('no-scroll');

            $('input[name="venue_options"]').prop('checked', false);

            $('[data-js="next-step"]').trigger('click');

            this.updateTableInfo();
        }

        onClickRemoveSelectedTableButton(e, imageMapName)
        {
            const shapeTitle = $(e.currentTarget).attr('data-table');
            this.tableSelection[shapeTitle] = false;

            this.deselectTable(imageMapName, shapeTitle)
        }

        confirmCalendarDateDialog(target, isEvent = false)
        {
            // open modal
            this.calendarConfirmModal = new Modal('booking-calendar-confirm-modal');

            if (target) {
                this.calendarConfirmModal.show();
            }

            const calendarDayEl = $(target).closest(this.selectors.calendarDay);

            let dateValue = calendarDayEl.attr('data-date');
            let dateText = calendarDayEl.attr('data-text');

            $('[data-js="calendar_confirm_modal_date"]').html(dateText);

            // choose day have event or day don't have event
            if (isEvent) {
                $(this.selectors.calendarModalViewEvent).removeClass('hidden');

                $(this.selectors.calendarModalViewEvent).on('click', function () {
                    window.location = $(target).find('a').attr('href');
                });
            } else {
                $(this.selectors.calendarModalViewEvent).addClass('hidden');
            }

            $(this.selectors.calendarConfirmModalButton).attr('data-date', dateValue);
        }

        highlightTables(sku)
        {
            $('.imp-shape').removeClass('table-available');
            $('.imp-shape[data-shape-title*="' + sku + '"]').addClass('table-available');
        }

        setTableAvailability()
        {
            $.ajax({
                type: 'POST',
                url: woocommerce_params.ajax_url,
                data: {
                    action: 'barfunk_table_availability',
                    date: this.getState('date'),
                },
                success: result => {
                    if (typeof result === 'string') {
                        result = JSON.parse(result);
                    }

                    $('[data-shape-title*=""]').removeClass('table-unavailable');

                    if (result.hasOwnProperty('skus')) {
                        result.skus.forEach(sku => {
                            if (! sku.includes(this.getState('table'))) {
                                return;
                            }

                            $('[data-shape-title*="' + sku + '"]').removeClass('table-available').addClass('table-unavailable');
                        });
                    }
                },
                error: error => {
                    console.log(error);
                },
            });
        }

        toggleTableOptions(value)
        {
            const selector = 'input[name="' + value + '_table_options"]';

            $(selector).closest('.c-visual-options').parent().find('.c-visual-options').hide();
            $(selector).closest('.c-visual-options').show();
        }

        onSelectTable(e, data)
        {
            if (typeof data === 'string') {
                data = JSON.parse(data);
            }

            console.log(data);

            if (data.hasOwnProperty('tables') && data.tables.length) {
                this.bulkAjaxAddToCart(data.tables);
                return;
            }

            this.setState('table-selection', data.table);
            this.setState('product_id', data.productId);
            this.setState('variation_id', data.variationId);

            $('[data-js="ajax-add-to-cart"]')
                .attr('href', '/?add-to-cart=' + data.variationId + '&attribute_pa_table=' + data.tableAttribute + '&quantity=1')
                .attr('product_id', data.productId)
                .attr('variation_id', data.variationId)
                .attr('table', data.table);

            $('[data-js="barfunk-table-name"]').html(data.details.name);
            $('[data-js="barfunk-table-image"]').attr('src', data.details.image);
            $('[data-js="barfunk-table-details-venue"]').html(data.details.venue);
            $('[data-js="barfunk-table-details-pax"]').html(data.details.pax);
            $('[data-js="barfunk-table-details-max-pax"]').html(data.details.maxPax);
            $('[data-js="barfunk-table-details-min-spend"]').html(data.details.minSpend);

            // Booking Date
            $('[data-js="barfunk-table-details-dateText"]').html(data.details.date);

            this.addToCartModal.show();
        }

        singleAjaxAddToCart(e)
        {
            e.preventDefault();

            let addToCartBtn = $(e.currentTarget);
            let viewBookingBtn = $('[data-js="booking-view-cart"]');
            let bookMoreBtn = $('[data-js="booking-book-more"]');

            addToCartBtn.removeClass('hidden');
            viewBookingBtn.addClass('hidden');
            bookMoreBtn.addClass('hidden');

            let data = {
                action: 'woocommerce_ajax_add_to_cart',
                product_id: this.getState('product_id'),
                quantity: 1,
                variation_id: this.getState('variation_id'),
                venue: this.getState('venue'),
                table: this.getState('table-selection'),
                reservation_date: this.getState('date'),
            };

            $(document.body).trigger('adding_to_cart', [addToCartBtn, data]);
            this.ajaxAddToCart(data, addToCartBtn, viewBookingBtn, bookMoreBtn);
        }

        bulkAjaxAddToCart(tables)
        {
            let addToCartBtn = $('.barfunk-reservation-check-out a');
            let viewBookingBtn = $('[data-js="booking-view-cart"]');
            let bookMoreBtn = $('[data-js="booking-book-more"]');

            addToCartBtn.removeClass('hidden');
            viewBookingBtn.addClass('hidden');
            bookMoreBtn.addClass('hidden');

            let bulkData = [];

            tables.forEach(table => {
                bulkData.push({
                    product_id: table.productId,
                    quantity: 1,
                    variation_id: table.variationId,
                    venue: table.details.venue,
                    table: table.table,
                });
            });

            let data = {
                action: 'woocommerce_ajax_add_to_cart',
                bulk_data: bulkData,
                reservation_date: this.getState('date'),
            };

            $(document.body).trigger('adding_to_cart', [addToCartBtn, data]);
            this.ajaxAddToCart(data, addToCartBtn, viewBookingBtn, bookMoreBtn);
        }

        ajaxAddToCart(data, addToCartBtn = null, viewBookingBtn = null, bookMoreBtn = null)
        {
            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                beforeSend: response => {
                    addToCartBtn.removeClass('completed').addClass('is-loading');
                },
                complete: response => {
                },
                success: response => {
                    if (response.error) {
                        if (response.product_url) {
                            window.location = response.product_url;
                        }

                        $('[data-js="modal-alerts"]').html(response.message).removeClass('hidden');

                        addToCartBtn.addClass('error').removeClass('is-loading');
                        setTimeout(() => {
                            addToCartBtn.removeClass('error');
                            $('[data-js="modal-alerts"]').addClass('hidden');
                        }, 2500);
                    } else {
                        addToCartBtn.addClass('completed').removeClass('is-loading');

                        if (viewBookingBtn) {
                            viewBookingBtn.removeClass('hidden');
                            addToCartBtn.addClass('hidden');
                        }

                        if (bookMoreBtn) {
                            bookMoreBtn.removeClass('hidden');
                        }

                        addToCartBtn.attr('data-success_message')

                        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, addToCartBtn]);

                        if (response.cart_url) {
                            window.location = response.cart_url;
                        }
                    }
                },
            });
        }

        getState(key)
        {
            return objectHelper.get(this.state, key);
        }

        setState(key, value)
        {
            objectHelper.set(this.state, key, value);
            localStorageHelper.set(this.id, this.state);

            this.updateReservationInfo(key, value);
        }

        updateReservationInfo(key, value)
        {
            if ('date' === key) {
                $('.barfunk-reservation-account-link').hide();
            }

            if (! value) {
                value = '';
                $('.barfunk-multistep-summary-item-' + key).removeClass('completed');
            } else {
                $('.barfunk-multistep-summary-item-' + key).addClass('completed');
            }

            if ($('.barfunk-reservation-info-' + key).length) {
                $('.barfunk-reservation-info-' + key).html(value.toUpperCase());
            }
        }
    }

    moduleRegistrar.register(new Module('barfunk-reservation', BarfunkReservation));
    moduleRegistrar.register(new Module('barfunk-booking-calendar', BarfunkBookingCalendar));

    $(document).ready(function () {
        moduleRegistrar.instantiate('barfunk-reservation');
        moduleRegistrar.instantiate('barfunk-booking-calendar');

        $('[data-js="multistep"]').on('multistep:step:changed', (e, data) => console.log(data));
    });
}) (
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module,
    window.webSCAPE.moduleRegistrar.getModule('webscape-modal').getClass(),
    window.webSCAPE.moduleRegistrar.getModule('webscape-local-storage').getInstance(),
    window.webSCAPE.moduleRegistrar.getModule('webscape-object-helper').getInstance()
);
